import { useEffect, useMemo, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _QuickturnAppointment } from "../../../../../../core/services/dataBean/QuickEntityCatalog";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { Alert } from "../../../../../../modules/theme/Component/Alert";

export const HistoryAppointmen = () => {

    const { instance } = useDataBean(_QuickturnAppointment);
    const [lista, setLista] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const pageSize = 15;

    useEffect(() => { getLista() }, []);

    const getLista = () => {
        instance.getAppointmentByAccount(null, null, _single.getAccountID(), null)
            .then((resp) => setLista(resp))
            .catch(err => toast.error(err));
    };

    const paginatedList = useMemo(() => {
        const start = (page - 1) * pageSize;
        return lista.slice(start, start + pageSize);
    }, [lista, page]);

    const totalPages = Math.ceil(lista.length / pageSize);

    const nextPage = () => setPage(p => Math.min(p + 1, totalPages));
    const prevPage = () => setPage(p => Math.max(p - 1, 1));

    return (
        <>
            {paginatedList.length > 0 ? (
                <div className="appointment-list">
                    {totalPages > 1 && (
                        <div className="pagination-controls">
                            <button disabled={page === 1} onClick={prevPage}>
                                Anterior
                            </button>

                            <span>Página {page} de {totalPages}</span>

                            <button disabled={page === totalPages} onClick={nextPage}>
                                Siguiente
                            </button>
                        </div>
                    )}
                    {paginatedList.map((item, index) => {
                        const data = item.DataBeanProperties;

                        const fromHour = data.FromDate?.split(" ")[1]?.substring(0, 5);
                        const untilHour = data.UntilDate?.split(" ")[1]?.substring(0, 5);

                        return (
                            <div className="appointment-card" key={index}>
                                <div className="icon-col">
                                    <div className="icon-circle">
                                        <i className="ri-calendar-check-line"></i>
                                    </div>
                                </div>

                                <div className="content-col">
                                    <h6 className="title">{data.AttentionIDName}</h6>

                                    <div className="subinfo">
                                        <span className="label">{data.AttentionOfficeName}</span>
                                    </div>

                                    <div className="subinfo">
                                        <span className="date">{data.FromDate.split(" ")[0]}</span>
                                        <span className="hour">{fromHour} - {untilHour}</span>
                                    </div>

                                    <div className="subinfo">
                                        <span className={`state state-${data.ProcessState}`}>
                                            {data.StateName}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>
            ) : (
                <Alert children={`Sin agendamientos`} clase="info" />
            )}
        </>
    );
};
